import { PREVIOUS_URL_KEY } from 'links/login/constants'
import {
	getFromSessionStorage,
	removeFromSessionStorage,
	setToSessionStorage,
} from 'utils/webStorage/sessionStorage'

export const getSessionStoragePreviousUrl = () =>
	getFromSessionStorage<string>(PREVIOUS_URL_KEY) ?? ''

export const setSessionStoragePreviousUrl = (url: string) =>
	setToSessionStorage(PREVIOUS_URL_KEY, url)

export const removeSessionStoragePreviousUrl = () =>
	removeFromSessionStorage(PREVIOUS_URL_KEY)
